module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-700.1c44e440b54050bdb9c8f4cf048163bc.woff2";